<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <el-col :span="12" style="text-align: left; font-size: 20px; color: #0a666b">
        <span class="el-icon-guide" style="font-size: 22px; cursor: pointer"></span>
        {{ $t('preprint.myTitle') }}
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-button
          type="primary"
          style="background-color: #0a666b; border: none"
          @click="submitNew()"
        >
          {{ $t('preprint.mySubmitNew') }}
        </el-button>
      </el-col>
    </el-row>

    <el-row style="background-color: white; padding-top: 20px">
      <el-form :inline="true" :model="searchForm" label-width="auto">
        <el-form-item :label="$t('preprint.myStatusFilter')">
          <el-select v-model="searchForm.status" :placeholder="$t('preprint.myStatusPlaceholder')">
            <el-option :label="$t('preprint.myStatusAll')" value=""></el-option>
            <el-option :label="$t('preprint.myStatusPending')" value="pending"></el-option>
            <el-option :label="$t('preprint.myStatusApproved')" value="approved"></el-option>
            <el-option :label="$t('preprint.myStatusRejected')" value="rejected"></el-option>
            <el-option :label="$t('preprint.myStatusOffline')" value="offline"></el-option>
            <el-option :label="$t('preprint.myStatusConverted')" value="converted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('preprint.myTitleLabel')">
          <el-input v-model="searchForm.title" :placeholder="$t('preprint.myTitlePlaceholder')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            style="background-color: #0a666b; color: white; border: none"
            @click="loadMyPreprintList()"
          >
            {{ $t('preprint.searchButton') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row v-if="preprintList.length == 0">
      <el-col :span="24">
        <el-empty
          :description="$t('preprint.myEmpty')"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>

    <el-row style="min-height: 900px">
      <el-col :span="24" style="margin-top: 10px">
        <el-card
          class="box-card"
          shadow="hover"
          v-for="(item, index) in preprintList"
          :key="index"
        >
          <div slot="header" class="card-header clearfix">
            <span class="preprint-title">
              《{{ item.title }}》
            </span>
            <el-tag
              :type="getStatusType(item.status)"
              size="small"
              class="status-tag"
            >
              {{ getStatusText(item.status) }}
            </el-tag>
          </div>
          <el-row>
            <el-col :span="20">
              <el-row>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.myNumber') }}:</span>
                  {{ item.preprintNumber }}
                </el-col>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.myType') }}:</span>
                  {{ item.preprintType }}
                </el-col>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.mySubmitTime') }}:</span>
                  {{ item.submitTime }}
                </el-col>
                <el-col :span="12" style="text-align: left; margin-top: 10px">
                  <span style="color: #0a666b">{{ $t('preprint.myViewDownload') }}:</span>
                  {{ item.viewCount }} / {{ item.downloadCount }}
                </el-col>
                <el-col :span="24" style="text-align: left; margin-top: 10px" v-if="item.convertedManuscriptId">
                  <el-tag type="success" size="small">
                    <i class="el-icon-check"></i>
                    {{ $t('preprint.myConvertedTag') }}
                  </el-tag>
                  <span style="margin-left: 10px; color: #67C23A; font-size: 12px">
                    {{ $t('preprint.myConvertedId') }}: {{ item.convertedManuscriptId }}
                  </span>
                </el-col>
                <el-col :span="24" style="text-align: left; margin-top: 10px" v-if="item.status === 'rejected' && item.auditOpinion">
                  <span style="color: #F56C6C; font-size: 12px">
                    <i class="el-icon-warning"></i>
                    {{ $t('preprint.myRejectedReason') }}: {{ item.auditOpinion }}
                  </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4" style="text-align: right">
              <el-button
                size="small"
                type="primary"
                @click="viewDetail(item.id)"
                style="background-color: #09666c; border: none; margin-bottom: 5px"
              >
                {{ $t('preprint.myViewDetail') }}
              </el-button>
              <br />
              <el-button
                v-if="item.status === 'rejected'"
                size="small"
                type="warning"
                @click="resubmit(item.id)"
                style="margin-bottom: 5px"
              >
                {{ $t('preprint.myResubmit') }}
              </el-button>
              <br v-if="item.status === 'rejected'" />
              <el-button
                v-if="item.status === 'approved' && !item.convertedManuscriptId"
                size="small"
                type="warning"
                @click="openConvertDialog(item)"
              >
                {{ $t('preprint.myConvert') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 转换确认对话框 -->
    <el-dialog
      title="转为正式稿件"
      :visible.sync="convertDialogVisible"
      width="500px"
    >
      <div style="line-height: 1.8">
        <p v-html="$t('preprint.convertDialogContent', { title: currentPreprint ? currentPreprint.title : '' })"></p>
        <p style="color: #E6A23C; font-size: 14px; margin-top: 20px">
          <i class="el-icon-warning"></i>
          {{ $t('preprint.convertDialogNote') }}
        </p>
      </div>
      <span slot="footer">
        <el-button @click="convertDialogVisible = false">{{ $t('preprint.convertCancel') }}</el-button>
        <el-button
          type="warning"
          @click="confirmConvert"
          :loading="converting"
        >
          {{ $t('preprint.convertConfirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMyPreprintList, convertToManuscript } from '@/api/preprint'

export default {
  name: 'myPreprintList',
  data() {
    return {
      userInfo: null,
      searchForm: {
        status: '',
        title: ''
      },
      preprintList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0,
      convertDialogVisible: false,
      converting: false,
      currentPreprint: null
    }
  },
  methods: {
    submitNew() {
      this.$router.push({ name: 'submitPreprint' })
    },
    viewDetail(id) {
      this.$router.push({
        name: 'preprintDetail',
        query: { id: id }
      })
    },
    resubmit(id) {
      this.$router.push({
        name: 'submitPreprint',
        query: { preprintId: id, mode: 'resubmit' }
      })
    },
    openConvertDialog(item) {
      this.currentPreprint = item
      this.convertDialogVisible = true
    },
    confirmConvert() {
      if (!this.currentPreprint) {
        return
      }

      this.converting = true
      convertToManuscript({
        userInfo: {
          email: this.userInfo.email,
          name: this.userInfo.name
        },
        preprintId: this.currentPreprint.id
      }).then((res) => {
        if (res.data.errorCode === 0) {
          const manuscriptId = res.data.result
          this.convertDialogVisible = false
          
          // 根据用户身份进行不同的处理
          const userType = this.userInfo.type
          
          if (userType === '投稿人') {
            // 投稿人：显示成功消息并询问是否跳转到"我的稿件"
            this.$message.success(this.$t('preprint.convertSuccess', { id: manuscriptId }))
            this.$confirm(this.$t('preprint.convertJumpConfirm'), this.$t('preprint.convertJumpTitle'), {
              confirmButtonText: this.$t('preprint.convertJumpYes'),
              cancelButtonText: this.$t('preprint.convertJumpNo'),
              type: 'success'
            }).then(() => {
              // 跳转到"我的稿件"列表页
              this.$router.push({
                name: 'manuscriptList'
              })
            }).catch(() => {
              // 刷新列表
              this.loadMyPreprintList()
            })
          } else if (userType === '责任编辑') {
            // 责任编辑：提示成功并跳转到责任编辑稿件列表
            this.$message({
              message: '转换成功！稿件已分配给您，请前往"稿件列表"进行审核',
              type: 'success',
              duration: 3000
            })
            setTimeout(() => {
              this.$router.push({
                name: 'editorList'
              })
            }, 1500)
          } else if (userType === '审稿人') {
            // 审稿人：提示等待责任编辑审核
            this.$alert(
              '转换成功！稿件已提交，正在等待责任编辑审核。责任编辑审核通过后会分配给审稿人进行审稿。',
              '转换成功',
              {
                confirmButtonText: '知道了',
                type: 'success',
                callback: () => {
                  // 刷新列表
                  this.loadMyPreprintList()
                }
              }
            )
          } else {
            // 其他身份：默认处理
            this.$message.success('转换成功！稿件ID: ' + manuscriptId)
            this.loadMyPreprintList()
          }
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.convertFailed'))
        }
      }).catch((err) => {
        console.error('转换错误:', err)
        this.$message.error(this.$t('preprint.convertFailed'))
      }).finally(() => {
        this.converting = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadMyPreprintList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadMyPreprintList()
    },
    getStatusType(status) {
      const typeMap = {
        pending: 'primary',
        approved: 'success',
        rejected: 'danger',
        offline: 'info',
        converted: 'warning'
      }
      return typeMap[status] || 'info'
    },
    getStatusText(status) {
      const keyMap = {
        pending: this.$t('preprint.myStatusPending'),
        approved: this.$t('preprint.myStatusApproved'),
        rejected: this.$t('preprint.myStatusRejected'),
        offline: this.$t('preprint.myStatusOffline'),
        converted: this.$t('preprint.myStatusConverted')
      }
      return keyMap[status] || status
    },
    loadMyPreprintList() {
      if (!this.userInfo) {
        this.$message.error(this.$t('preprint.needLogin'))
        this.$router.push({ name: 'login' })
        return
      }

      getMyPreprintList({
        userInfo: {
          email: this.userInfo.email
        },
        current: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.preprintList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || '加载失败')
        }
      }).catch((err) => {
        console.error('加载我的预印本列表错误:', err)
        this.$message.error('加载失败')
      })
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    this.loadMyPreprintList()
  }
}
</script>

<style scoped>
.box-card {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

/* 卡片头部样式，确保标题完整显示 */
.card-header {
  min-height: 40px;
  padding: 10px 0;
  line-height: 1.5;
  overflow: visible;
}

.card-header::after {
  content: "";
  display: table;
  clear: both;
}

/* 标题样式，确保不被遮挡 */
.preprint-title {
  color: #0a666b;
  font-weight: 900;
  float: left;
  line-height: 1.5;
  padding: 5px 0;
  word-break: break-word;
  overflow: visible;
  max-width: calc(100% - 120px);
}

/* 状态标签样式 */
.status-tag {
  float: right;
  margin-left: 10px;
  margin-top: 5px;
}
</style>




// WEBPACK FOOTER //
// src/view/preprint/myPreprintList.vue